import { classNames } from '@ember-decorators/component';
import DynamicFieldBase from '../dynamic-field-base';

// Default implementation of the jurisdictional ID field that dynamic-field.hbs
// invokes as <Learner::IdSearchField>. Every app consuming linced-common must
// be able to resolve this component or its build fails under embroider.
@classNames('id-search-field')
export default class IdSearchField extends DynamicFieldBase {}
